$(() => {
  const pluginName = 'contactModal';

  /**
   * Does its best to find a thing to focus and then focuses it
   * @param $thing
   */
  const focusFirstFocusableThing = ($thing) => {
    const $focusableThing = $thing.find('a,button,input').filter(':visible');

    if ($focusableThing.length) {
      $focusableThing.first().focus();
    }
  };

  /**
   * Open up the event organizer contact panel
   * @param data
   */
  const toggleContactEventOrganizer = (data) => {
    data.elements.$contactMenu.addClass('hidden');
    data.elements.$contactEventOrganizer.removeClass('hidden');
    focusFirstFocusableThing(data.elements.$contactEventOrganizer);
  };

  /**
   * Load the HubSpot contact form into its embed container when needed.
   * @param $container
   */
  const loadHubspotContactSupportForm = ($container) => {
    const embed = $container.find('.js-hubspot-contact-support-form')[0];

    if (embed && typeof embed.loadHubspotContactSupportForm === 'function') {
      embed.loadHubspotContactSupportForm();
    }
  };

  /**
   * Open up the Race Roster contact panel
   * @param data
   */
  const toggleContactRaceRoster = (data) => {
    data.elements.$contactMenu.addClass('hidden');
    data.elements.$contactRaceRoster.removeClass('hidden');
    loadHubspotContactSupportForm(data.elements.$contactRaceRoster);
    focusFirstFocusableThing(data.elements.$contactRaceRoster);
  };

  /**
   * Go back to the contact modal menu
   * @param data
   * @param shouldFocus
   */
  const toggleMenu = (data, shouldFocus = true) => {
    data.elements.$contactEventOrganizer.addClass('hidden');
    data.elements.$contactRaceRoster.addClass('hidden');
    data.elements.$contactMenu.removeClass('hidden');

    if (shouldFocus) {
      focusFirstFocusableThing(data.elements.$contactMenu);
    }
  };

  /**
   * When the modal closes, reset everything in the modal back to its original state
   * @param data
   */
  const onClose = (data) => {
    toggleMenu(data, false);
    data.elements.$contactRaceRoster.trigger('raceRoster.preventDoubleSubmission.reEnable');
  };

  /**
   * Gimme all the things
   * @param $element
   * @returns {object}
   */
  const getElements = ($element) => ({
    $contactModal: $element,
    $contactMenu: $element.find('.js-contact-modal-menu'),
    $contactEventOrganizerToggle: $element.find('.js-contact-event-organizer-toggle'),
    $contactRaceRosterToggle: $element.find('.js-contact-race-roster-toggle'),
    $contactEventOrganizer: $element.find('.js-contact-event-organizer'),
    $contactRaceRoster: $element.find('.js-contact-race-roster'),
    $contactMenuBack: $element.find('.js-contact-back-to-menu'),
    $contactName: $element.find('.js-contact-name'),
    $contactEmail: $element.find('.js-contact-email'),
    $contactSubject: $element.find('.js-contact-subject'),
    $contactMessage: $element.find('.js-contact-message'),
    $contactPhone: $element.find('.js-contact-phone'),
    $contactFile: $element.find('.js-contact-file'),
    $contactEventId: $element.find('.js-contact-event-id'),
    $contactClubId: $element.find('.js-contact-club-id'),
    $snackBar: $('[data-js-snack-bar]'),
  });

  $.fn[pluginName] = function Plugin(options) {
    const initialize = (index, element) => {
      const $element = $(element);
      const data = {
        settings: $.extend(true, {}, $.fn[pluginName].defaults, options),
        elements: getElements($element),
      };

      data.elements.$contactModal
        .on('hidden.bs.modal', () => onClose(data))
        .on('shown.bs.modal', () => $.fn.googleRecaptcha.fire());

      data.elements.$contactEventOrganizerToggle
        .on('click', () => toggleContactEventOrganizer(data));
      data.elements.$contactRaceRosterToggle.on('click', () => toggleContactRaceRoster(data));
      data.elements.$contactMenuBack.on('click', () => toggleMenu(data));
    };

    return this.each(initialize);
  };
});
